import { createApp } from 'vue'
import App from './EnvironmentReport.vue'

createApp(App).mount('#app-environment-report')
